import type { GetTimesheetSetupRequestPayload } from './types/kiosk';
import type { TimesheetSetup } from './types/timesheetSetup';
import { KioskCommand } from './postKioskApi';
import { usePostKioskApi } from './usePostKioskApi';

export async function fetchTimesheetSetup(
  payload: GetTimesheetSetupRequestPayload
): Promise<TimesheetSetup> {
  const postKioskApi = usePostKioskApi();
  return await postKioskApi<TimesheetSetup>(
    KioskCommand.getTimesheetSetup,
    payload
  );
}
